import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ClipboardCheck, User, Users, Hand, Tent, ArrowUpRight, Check } from 'lucide-react';
import SectionHead from '@/components/SectionHead';
import { PROGRAMS } from '@/data/content';
import { fadeUp, stagger, viewportOnce, scrollToHash } from '@/lib/motion';

const ICONS = { ClipboardCheck, User, Users, Hand, Tent };

export default function Programs() {
  return (
    <section id="additional-programs" className="relative py-24 sm:py-32 bg-night" data-testid="programs-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHead
          chapter="05"
          eyebrow="Additional Programs"
          title={'SPECIALIZED\nTRAINING.'}
          description="Optional programs built around your player's individual goals — evaluations, private training, small groups, goalkeepers and seasonal camps."
          testId="programs-heading"
        />
        <motion.div
          variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce}
          className="grid md:grid-cols-2 xl:grid-cols-3 gap-6"
        >
          {PROGRAMS.map((p, i) => {
            const Icon = ICONS[p.icon];
            return (
              <motion.div
                key={p.title} variants={fadeUp} custom={i}
                whileHover={{ y: -6 }}
                className={`glass-card rounded-sm p-8 flex flex-col group hover:border-brand-gold/40 transition-[border-color,transform] duration-300 ${i === 0 ? 'md:col-span-2 xl:col-span-1' : ''}`}
                data-testid={`program-${p.title.toLowerCase().replace(/[^a-z]+/g, '-')}`}
              >
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 flex items-center justify-center rounded-sm bg-brand-gold/10 border border-brand-gold/30 text-brand-gold">
                    <Icon size={22} strokeWidth={1.75} />
                  </div>
                  <ArrowUpRight size={20} className="text-gray-600 group-hover:text-brand-gold group-hover:translate-x-1 group-hover:-translate-y-1 transition-[color,transform] duration-300" />
                </div>
                <h3 className="mt-6 font-display text-2xl tracking-wide text-white uppercase">{p.title}</h3>
                <p className="mt-2 text-sm text-gray-400 leading-relaxed">{p.blurb}</p>
                <div className="mt-5 flex flex-wrap gap-2 flex-1">
                  {p.items.map(item => (
                    <span key={item} className="flex items-center gap-1.5 text-xs text-gray-300 border border-white/10 rounded-full px-3 py-1.5">
                      <Check size={11} className="text-brand-red" /> {item}
                    </span>
                  ))}
                </div>
                {p.hash ? (
                  <button onClick={() => scrollToHash(p.hash)} data-testid={`program-cta-${i}`}
                    className="mt-7 border border-brand-gold/60 text-brand-gold hover:bg-brand-gold hover:text-night font-display tracking-widest text-lg py-3 rounded-sm transition-colors duration-300">
                    {p.cta.toUpperCase()}
                  </button>
                ) : (
                  <Link to={`/register?program=${encodeURIComponent(p.program)}`} data-testid={`program-cta-${i}`}
                    className="mt-7 text-center border border-brand-gold/60 text-brand-gold hover:bg-brand-gold hover:text-night font-display tracking-widest text-lg py-3 rounded-sm transition-colors duration-300">
                    {p.cta.toUpperCase()}
                  </Link>
                )}
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
